import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App.jsx';
import * as serviceWorker from './serviceWorker';
import { sanitizeUrl } from './utils/sanitize';

const originalWindowOpen = window.open.bind(window);

window.open = (url, target = '_blank', features = '') => {
  const safeUrl = sanitizeUrl(url);
  if (!safeUrl) {
    return null;
  }

  const safeFeatures = features
    ? `${features},noopener,noreferrer`
    : 'noopener,noreferrer';

  return originalWindowOpen(safeUrl, target, safeFeatures);
};

ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
